// Shareable deep-link helpers for tasks. A task link uses a hash fragment
// (#task-{id}) on the project route so it can be pasted into chat/email and
// land the user directly on the task — ProjectDetail reads the hash on mount,
// expands the containing workstream if collapsed, scrolls to the task, and
// briefly highlights it.

const TASK_HASH_PREFIX = 'task-';

export function taskShareUrl(projectId: string, taskId: string): string {
  const origin = typeof window !== 'undefined' ? window.location.origin : '';
  return `${origin}/Projects/${projectId}#${TASK_HASH_PREFIX}${taskId}`;
}

export function readTaskHash(): string | null {
  if (typeof window === 'undefined') return null;
  const h = window.location.hash || '';
  if (!h.startsWith(`#${TASK_HASH_PREFIX}`)) return null;
  const id = h.slice(TASK_HASH_PREFIX.length + 1);
  return id || null;
}

// Best-effort clipboard copy that falls back to a hidden textarea + execCommand
// for browsers without the async Clipboard API (e.g. older Safari, insecure
// origins). Returns true on success.
export async function copyToClipboard(text: string): Promise<boolean> {
  try {
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(text);
      return true;
    }
  } catch (e) { /* fall through */ }
  try {
    const ta = document.createElement('textarea');
    ta.value = text;
    ta.setAttribute('readonly', '');
    ta.style.position = 'absolute';
    ta.style.left = '-9999px';
    document.body.appendChild(ta);
    ta.select();
    const ok = document.execCommand('copy');
    document.body.removeChild(ta);
    return ok;
  } catch (e) {
    return false;
  }
}
